import TabbedHub from '../components/TabbedHub';
import LearnPage from './LearnPage';
import FutureCareersPage from './FutureCareersPage';
import FinancialLiteracyPage from './FinancialLiteracyPage';

/**
 * Learning, resources and money basics in one place.
 *
 * Future Careers Hub called no live data and carried hardcoded 2025 job-market figures; the stat
 * cards are gone and what was worth keeping, certifications, free resources, AI tools, lives
 * here as resources. Financial Literacy is teaching material, not a decision tool, so it moved out
 * of the money group and in here.
 */
export default function LearnHubPage() {
  return (
    <TabbedHub testid="learn-hub" tabs={[
      { key: 'learn', label: 'Learn', render: () => <LearnPage /> },
      { key: 'resources', label: 'Resources & Certifications', render: () => <FutureCareersPage /> },
      { key: 'money-basics', label: 'Money Basics', render: () => <FinancialLiteracyPage /> },
    ]} />
  );
}
